import { Routes,Route } from 'react-router-dom';
import Full from './components/layout/Full';
import Page from './components/layout/Page';
import Login from './page/authlogin/Login';
import ProtectedRoute from './page/authlogin/ProtectedRoute';
import Home from "./page/home/Home";
import Settings from './page/user/SettingsUser';
import Security from './page/user/SecurityUser';
import Profile from './page/user/ProfileUser';
import Client from './page/client/Client';
import ClientDetail from './page/client/ClientDetail';
import Event from './page/event/Event';
import EventDetail from './page/event/EventDetail';
import Contract from './page/contract/Contract';
import ContractAdd from './page/contract/ContractAdd';
import ContractEdit from './page/contract/ContractEdit';
import ContractDuplicate from './page/contract/ContractDuplicate';
import Material from './page/material/Material';
import Category from './page/material/Category';
import SchedulePay from './page/schedulepay/SchedulePay';
import CreditNote from './page/schedulepay/CreditNote';
import CalendarTimeline from './page/timeline/CalendarTimeline';
import ActivityGroup from './page/timeline/ActivityGroup';
import Register from './page/Register';

export default function Main() {

  	return (
	    <Routes>
            {/* Layout full without header and footer */}
            <Route element={<Full />}>
                <Route path="/login" element={<Login />} />
            </Route>
            {/* Route protette */}
            <Route element={<Page />}>
                <Route path="/" element={<ProtectedRoute requiredRole={false} element={Home} />}  />
                <Route path="/home" element={<ProtectedRoute requiredRole={false} element={Home} />}  />
                <Route path="/profile-user" element={<ProtectedRoute requiredRole={false} element={Profile} />}  />
                <Route path="/settings-user" element={<ProtectedRoute requiredRole={false} element={Settings} />}  />
                <Route path="/security-user" element={<ProtectedRoute requiredRole={false} element={Security} />}  />
                <Route path="/client" element={<ProtectedRoute requiredRole={false} element={Client} />}  />
                <Route path="/client-detail/:id" element={<ProtectedRoute requiredRole={false} element={ClientDetail} />}  />
                <Route path="/event" element={<ProtectedRoute requiredRole={false} element={Event} />}  />
                <Route path="/event-detail/:id" element={<ProtectedRoute requiredRole={false} element={EventDetail} />}  />
                <Route path="/contract" element={<ProtectedRoute requiredRole={false} element={Contract} />}  />
                <Route path="/contract-add" element={<ProtectedRoute requiredRole={false} element={ContractAdd} />}  />
                <Route path="/contract-edit/:id" element={<ProtectedRoute requiredRole={false} element={ContractEdit} />}  />
                <Route path="/contract-duplicate/:id" element={<ProtectedRoute requiredRole={false} element={ContractDuplicate} />}  />
                <Route path="/materials" element={<ProtectedRoute requiredRole={false} element={Material} />}  />
                <Route path="/categories" element={<ProtectedRoute requiredRole={false} element={Category} />}  />
                <Route path="/schedule-pay" element={<ProtectedRoute requiredRole={false} element={SchedulePay} />}  />
                <Route path="/credit-note" element={<ProtectedRoute requiredRole={false} element={CreditNote} />}  />
                <Route path="/timeline" element={<ProtectedRoute requiredRole={false} element={CalendarTimeline} />}  />
                <Route path="/activity-groups" element={<ProtectedRoute requiredRole={false} element={ActivityGroup} />}  />
                <Route path="/register"  element={<ProtectedRoute requiredRole={true} roles={'ROLE_ADMIN'} element={Register} />}  />
            </Route>
            {/* /Route protette */}
		</Routes>
	);
}